import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import uniqueId from 'lodash/uniqueId';

import { hasProp } from '~/src/helpers/object';

export const quantityHdChannels = channels => channels.reduce((quantityHd, channel) => {
    const currentHd = hasProp(channel, 'quality') && channel.quality === 'HD' ? 1 : 0;
    return quantityHd + currentHd;
}, 0);

export const searchCategory = (themes, label) => {

    let category = { value: 0, label: 'Все каналы' };

    themes.forEach(item => {
        if (item.label === label) {
 category = item;
}
    });

    return category;
};

export const filteringTariffs = (tariffs, filteredTariffsId) => {
    if (filteredTariffsId && Array.isArray(filteredTariffsId) && filteredTariffsId.length) {
        return tariffs.reduce((acc, tariff) => {
            if (filteredTariffsId.find(id => tariff.id === id)) {
 acc.push(tariff);
}
            return acc;
        }, []);
    } else {
        return tariffs;
    }
};

export const createTariffBuilder = (price) => ({
    salePackage2in1: {
        is_cottage: 0,
        free_packets: '',
        price_final: price,
        promo_price_final: 0,
        promo_duration_final: 0,
    },
    description: {
        color: '',
        color_title_start: COLORS.TextPrimary,
        color_title_end: COLORS.TextPrimary,
        alias: 'constructor',
        color_text: COLORS.TextPrimary,
        description: 'Соберите тариф только из&nbsp;того, что нужно: онлайн-кинотеатры, подписки на&nbsp;полезные сервисы, пакеты каналов и&nbsp;многое другое',
        image_background: '/static/images/tariff-builder/constructor-card-background.png',
        image_background_webp: '/static/images/tariff-builder/constructor-card-background.webp',
        sort_on_bundles: 0,
        sort_on_internet: 0,
        sort_on_internet_lines: 0,
        tariffLine: {
            id: 1,
            title: '',
            body: '',
            sort: 1,
            title_short: '',
            url_landing: '',
        },
        title: 'Тариф Конструктор',
        weight: 0,
        available_on_main_page: 1,
        available_on_internet_page: 1,
        sort: 0,
    },
    additionalProducts: [],
    hasRequiredEquipment: 0,
    lineId: 0,
    location: '',
    offerContents: [],
    sale_package_id: uniqueId(),
    productType: 100,
    salePackageLinks: [],
    speed_int: 0,
    speed_bonus: 0,
    available_on_main_page: 1,
    available_on_internet_page: 1,
    is_cottage: 0,
    price_final: price,
    tariff_name_display: 'Тариф Конструктор',
    sort_on_bundles: 0,
    sort_on_internet: 0,
    sort_on_internet_lines: 0,
});

